import React, { Component } from 'react';

class SearchPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: ''
    };
    
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    // Фокусируемся на поле ввода при открытии
    if (this.props.show) {
      setTimeout(() => {
        this.searchInputRef.current?.focus();
      }, 100);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      // Фокусируемся при открытии
      setTimeout(() => {
        this.searchInputRef.current?.focus();
      }, 100);
    }
  }

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const { searchQuery } = this.state;
    
    if (searchQuery.trim()) {
      // Закрываем попап
      if (this.props.onClose) {
        this.props.onClose();
      }
      
      // Переходим на страницу поиска
      window.location.href = `/search?find=${encodeURIComponent(searchQuery.trim())}`;
    }
  };

  handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && this.props.onClose) {
      this.props.onClose();
    }
  };

  handleKeyDown = (e) => {
    if (e.key === 'Escape' && this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { show } = this.props;
    const { searchQuery } = this.state;

    if (!show) return null;

    return (
      <>
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-[4.6px] z-50 transition-opacity"
          onClick={this.handleBackdropClick}
          onKeyDown={this.handleKeyDown}
          role="presentation"
        />

        {/* Search Popup */}
        <div
          className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-20px)] mx-auto max-w-[500px] bg-white rounded-[25px] shadow-xl z-50 overflow-hidden"
          role="dialog"
          aria-modal="true"
        >
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-100">
            <h2 className="text-xl font-semibold text-[#032432]">Поиск</h2>
            <button
              onClick={this.props.onClose}
              className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors flex items-center justify-center"
              aria-label="Закрыть"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M1 1L13 13" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M13 1L1 13" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </button>
          </div>

          {/* Search Form */}
          <div className="p-6">
            <form onSubmit={this.handleSearchSubmit}>
              <div className="relative">
                <input
                  ref={this.searchInputRef}
                  type="text"
                  value={searchQuery}
                  onChange={this.handleSearchChange}
                  placeholder="Введите запрос..."
                  className="w-full h-[50px] pl-4 pr-12 rounded-lg border border-gray-300 
                    focus:outline-none focus:border-[#009EE3] focus:ring-1 focus:ring-[#009EE3]
                    text-[16px] transition-all"
                  autoComplete="off"
                />
                <button
                  type="submit"
                  className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 
                    bg-[#009EE3] hover:bg-[#0077b3] rounded-lg transition-colors
                    flex items-center justify-center"
                  aria-label="Найти"
                >
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M17 17L14 14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default SearchPopup;